import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-contact-form',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule,
     ReactiveFormsModule, CommonModule, MatInputModule, TranslateModule],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss'
})
export class ContactFormComponent {

  contactForm: FormGroup;
  sending = false;
  error_message = '';
  confirmation_message = '';

  constructor(private http: HttpClient, private fb: FormBuilder, public dialogRef: MatDialogRef<ContactFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.contactForm = this.fb.group({
      subject: ['', Validators.required],
      message: ['', Validators.required]
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  send(): void {
    this.sending = true;
    this.error_message = '';
    this.confirmation_message = '';
    if (this.contactForm.valid) {
    this.http.post(environment.url + '/api/v1/payments/send_email_to_support', this.contactForm.value).subscribe((res: any) => {
      this.sending = false;
      this.error_message = '';
      this.confirmation_message = 'Ticket enviado correctamente';

    }, (error: any) => {
      this.sending = false;
        this.error_message = error.error.message;
      });
    } else {
      this.sending = false;
      this.contactForm.markAllAsTouched();
      this.error_message = 'Hay algun campo incompleto.';
    }
  } 

  closeMessage(): void {
    this.error_message = '';
    this.confirmation_message = '';
  }

}
